// extracted by mini-css-extract-plugin
export default {"shell":"AppLayout_shell__WH24H","body":"AppLayout_body__CTw3H","content":"AppLayout_content__simgg","scrim":"AppLayout_scrim__Dn0ut"};